// extracted by mini-css-extract-plugin
export default {"titleText":"titles-module__titleText___KQtb_","subtitleText":"titles-module__subtitleText___uDTDR"};